export * from './consentsoftware.interfaces.objects';
export * from './consentsoftware.interfaces.request';
